<template>
  <div>
    <v-dialog
      v-model="modal_delete"
      persistent
      max-width="460px"
      content-class="hapus-dialog"
    >
      <v-card class="hapus-card">
        <!-- Header -->
        <div class="hapus-header">
          <v-btn
            icon
            small
            class="hapus-close"
            :disabled="!lbtn"
            @click="close_modal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div class="hapus-icon-wrap">
            <v-icon size="34" color="error"> mdi-trash-can-outline </v-icon>
          </div>

          <div class="hapus-title">Hapus Data?</div>

          <div class="hapus-subtitle">
            Tindakan ini memerlukan konfirmasi Anda.
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Content -->
        <v-card-text class="hapus-content">
          <div class="hapus-warning">
            <v-icon color="error" size="21" class="mr-2">
              mdi-alert-circle-outline
            </v-icon>

            <div>
              <div class="hapus-warning-title">
                Apakah Anda yakin ingin menghapus data ini?
              </div>

              <div class="hapus-warning-text">
                Data yang telah dihapus tidak dapat dikembalikan. Pastikan Anda
                telah memilih data yang benar.
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Footer -->
        <v-card-actions class="hapus-footer">
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            class="hapus-btn-cancel"
            :disabled="!lbtn"
            @click="close_modal()"
          >
            <v-icon left size="18">mdi-close</v-icon>
            Batal
          </v-btn>

          <v-btn
            color="error"
            depressed
            class="hapus-btn-confirm"
            :loading="!lbtn"
            :disabled="!lbtn"
            @click="hapus()"
          >
            <v-icon v-if="lbtn" left size="18"> mdi-trash-can-outline </v-icon>
            Ya, Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";

import "@/assets/styles/pages/anjab/infojabatan/wewenang/delete.css";

import SData from "@/store/anjab/infojabatan/wewenang";

export default {
  data: () => ({
    token: "",
    lbtn: true,
  }),

  computed: {
    modal_delete: {
      get() {
        return SData.state.modal_delete;
      },

      set(value) {
        SData.commit("open_delete", value);
      },
    },

    // Data yang dipilih untuk dihapus
    item() {
      return SData.state.data;
    },
  },

  watch: {
    async modal_delete(value) {
      if (value) {
        this.lbtn = true;
        this.token = await Cookie.get("token");
      }
    },
  },

  methods: {
    async hapus() {
      if (!this.lbtn) return;

      const item = this.item || {};
      const id = item.id || item.ID_INFO;

      if (!id) {
        SData.commit("alert", "ID data yang akan dihapus tidak ditemukan");
        SData.commit("gagalAlert", true);
        SData.commit("berhasilAlert", false);
        return;
      }

      this.lbtn = false;

      const url = `${process.env.VUE_APP_API}/wewenang/hapus/${encodeURIComponent(
        id,
      )}`;

      this.axios
        .delete(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.lbtn = false;
          if (res.data.success) {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Data Berhasil Di Hapus");
            SData.commit("alert_b", true);
            SData.commit("alert_g", false);
          } else {
            SData.commit("refresh", true);
            SData.commit("alert_text", "Data Gagal Di Hapus");
            SData.commit("alert_g", true);
            SData.commit("alert_b", false);
          }

          this.close_modal();
        })
        .catch((error) => {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Data Gagal Di Hapus");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
          // console.log(error.response.status);
          // console.log("Error", error.message);
          console.log(error);
          this.lbtn = false;

          this.close_modal();
        });
    },

    async close_modal() {
      SData.commit("close_delete", false);
      this.lbtn = false;
    },
  },
};
</script>
